module.exports = __webpack_public_path__ + "img/bank-title.f358e3b3.png";